'use strict';

import React, { useState } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import cn from 'classnames/bind';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';
import { locationsOperations } from '@/state/domains/locations';
import { locationListOperations } from '@/state/domains/locationList';
import { placesSelectors, placesOperations } from '@/state/domains/places';
import { DEFAULT_OPTS } from '@/state/domains/attempts/utils';

//import s from './styles.scss';
import m from '../styles.scss';
import s from './styles.scss';

const sx = cn.bind(s);

const SLM = 1;
const PCAS = 2;
const SERVICE = 'SERVICE';
const PICKUP = 'PICKUP';
const DELIVERY = 'DELIVERY';
const METHOD_ADDRESS = 'METHOD_ADDRESS';
const METHOD_PLACE = 'METHOD_PLACE';

export default connect(
	(state, props) => ({
		modals: appSelectors.getModalStates(state, props),
		modalProps: appSelectors.getModalProps(state, props),
		date: appSelectors.getPageDate(state, props),
		username: appSelectors.getPageUsername(state, props),
	}),
	{
		setModalClose: appOperations.setModalClose,
		findAddress: locationsOperations.findAddress,
		addToRoute: locationListOperations.postAddToRoute,
		searchPlaces: placesOperations.searchPlaces,
	}
)(
	({
		modals,
		modalProps,
		date,
		username,
		selectedIndices,
		setModalClose,
		findAddress,
		addToRoute,
		searchPlaces,
	}) => {

		const { locationList } = modalProps;

		if (!locationList) {
			return <div />;
		}

		const customStyles = {
			container: () => ({
				display: 'flex',
				flexDirection: 'column',
				flex: 1,
			}),
			menu: () => ({
				marginTop: '8px',
				marginBottom: '8px',
				textAlign: 'center',
			}),
		};

		const [ placeId, setPlaceId ] = useState(null);
		const [ locationId, setLocationId ] = useState(null);
		const [ recipient, setRecipient ] = useState({ label: '', value: '' });
		const [ jobHide, setJobHide ] = useState(true);
		//const [ jobId, setJobId ] = useState({ label: '', value: '' });
		const [ companyId, setCompanyId ] = useState(SLM);
		const [ task, setTask ] = useState(SERVICE);
		const [ method, setMethod ] = useState(METHOD_ADDRESS);

		const index = locationList.findIndex(i => i.isChecked);

		const onJobIdChange = (txt, state) => {

			const { action } = state;

			if (action === 'input-change') {
				setJobId({ label: txt, value: txt });
			}
		};

		const onRecipientChange = (txt, state) => {

			const { action } = state;

			if (action === 'input-change') {
				setRecipient({ label: txt, value: txt });
			}
		};

		const onCancel = () => {

			setRecipient({ label: '', value: '' });
			setCompanyId(SLM);
			setTask(SERVICE);
			setJobHide(true);
			setModalClose('addToRoute');
		};

		let timeoutIdAddress;

		const loadAddressOptions = inputValue => new Promise((resolve, reject) => {
			
			if (timeoutIdAddress) {
				clearTimeout(timeoutIdAddress);
			}

			timeoutIdAddress = setTimeout(
				() => {
					findAddress(inputValue).then(result => {

						const { data: { addresses }} = result;

						const opts = addresses.map(
							a => ({ label: a.address, value: a.placeId })
						);

						resolve(opts);
					});
				},
				1000
			);
		});

		let timeoutIdPlace;

		const loadPlaceOptions = inputValue => new Promise((resolve, reject) => {
			
			if (timeoutIdPlace) {
				clearTimeout(timeoutIdPlace);
			}

			timeoutIdPlace = setTimeout(
				() => {
					searchPlaces(inputValue).then(result => {

						const { data: { places }} = result;

						const opts = places.map(
							p => ({ label: p.name, value: p.locationId })
						);

						resolve(opts);
					});
				},
				1000
			);
		});

		const onAddressChange = ({ label, value }) => {
			setPlaceId(value);
		};

		const onPlaceChange = ({ label, value }) => {
			setLocationId(value);
		};

		const onSubmit = () => {
			const data = {
				method,
				username,
				date,
				placeId,
				locationId,
				companyId,
				task,
				recipient: recipient.value,
				index,
			};
			addToRoute(data);
			setModalClose('addToRoute');
		};

		return (
			<Modal
				appElement={ document.getElementById('root') }
				overlayClassName={ m.modalOverlay }
				isOpen={ modals.addToRoute }
				contentLabel='Add to Route'
				shouldCloseOnOverlayClick={ true }
				shouldCloseOnEsc={ true }
				onRequestClose={ () => setModalClose('addToRoute') }
				className={ m.modal }
			>
				<div className={ s.cont }>
					<p className={ s.header }>Add to Route</p>
					<div className={ s.contents }>
						<div className={ sx('row') }>
							<div className={ s.methodBtns }>
								<button
									className={
										sx(
											'methodBtn',
											{ active: method === METHOD_ADDRESS }
										)
									}
									onClick={ () => setMethod(METHOD_ADDRESS) }
								>
									New Address
								</button>
								<button
									className={
										sx(
											'methodBtn',
											{ active: method === METHOD_PLACE }
										)
									}
									onClick={ () => setMethod(METHOD_PLACE) }
								>
									Existing Place
								</button>
							</div>
						</div>
						{ method === METHOD_ADDRESS &&
							<div className={ sx('row') }>
								<label className={ s.rowLabel }>Address</label>
								<div className={ s.value }>
									<AsyncSelect
										loadOptions={ loadAddressOptions }
										onChange={ onAddressChange }
									/>
								</div>
							</div>
						}
						{ method === METHOD_PLACE &&
							<div className={ sx('row') }>
								<label className={ s.rowLabel }>Place</label>
								<div className={ s.value }>
									<AsyncSelect
										loadOptions={ loadPlaceOptions }
										onChange={ onPlaceChange }
									/>
								</div>
							</div>
						}
						{ jobHide && (
							<div className={ sx('row') }>
								<div
									className={ s.addJob }
									onClick={ () => setJobHide(false) }
								>
									<FontAwesomeIcon icon='plus'/>&nbsp;Add Job
								</div>
							</div>
						)}
						{ !jobHide && (
							<>
								<div className={ s.row }>
									<div className={ s.cols }>
										<label
											className={ s.oneOff }
											onClick={ () => setJobHide(true) }
										>
											<input type='checkbox' checked={ true } readOnly />
											&nbsp;Create one-off Job
										</label>
									</div>
								</div>
								{ false && <div className={ s.row }>
									<div className={ s.cols }>
										<label className={ s.colLabel }>Company</label>
										<div className={ s.companyBtns }>
											<button
												className={
													sx(
														'companyBtn',
														{ active: companyId === SLM }
													)
												}
												onClick={ () => setCompanyId(SLM) }
											>
												SLM
											</button>
											<button
												className={
													sx(
														'companyBtn',
														{ active: companyId === PCAS }
													)
												}
												onClick={ () => setCompanyId(PCAS) }
											>
												PCAS
											</button>
										</div>
									</div>
								</div> }
								<div className={ s.row }>
									<div className={ s.cols }>
										<label className={ s.colLabel }>Type</label>
										<div className={ s.taskOptions }>
											<button
												className={
													sx(
														'taskBtn',
														{ active: task === SERVICE }
													)
												}
												onClick={ () => setTask(SERVICE) }
											>
												Service
											</button>
											<button
												className={
													sx(
														'taskBtn',
														{ active: task === PICKUP }
													)
												}
												onClick={ () => setTask(PICKUP) }
											>
												Pickup
											</button>
											<button
												className={
													sx(
														'taskBtn',
														{ active: task === DELIVERY }
													)
												}
												onClick={ () => setTask(DELIVERY) }
											>
												Delivery
											</button>
										</div>
									</div>
								</div>
								{ task !== PICKUP &&
									<div className={ s.row }>
										<label className={ s.rowLabel }>Recipient</label>
										<Creatable
											placeholder='Recipient'
											value={ recipient }
											options={ [] }
											onInputChange={ onRecipientChange }
											maxMenuHeight={ 148 }
											styles={{
												menu: (provided, state) => ({
													...provided,
													display: 'none',
												}),
												indicatorsContainer: (provided, state) => ({
													...provided,
													display: 'none',
												}),
												indicatorSeparator: (provided, state) => ({
													...provided,
													display: 'none',
												}),
											}}
										/>
									</div>
								}
							</>
						)}
					</div>
					<div className={ s.footer }>
						<div className={ m.btns }>
							<button
								onClick={ onCancel }
								className={ m.cancel }
							>
								Cancel
							</button>
							<button
								onClick={ onSubmit }
								className={ m.proceed }
							>
								OK
							</button>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
);
